import { render, staticRenderFns } from "./PreviewTextElement.vue?vue&type=template&id=63c7ccf0&"
import script from "./PreviewTextElement.vue?vue&type=script&lang=js&"
export * from "./PreviewTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports